import { getErrorMessage } from 'shared/api/helpers/error-helper';
import { instance } from 'shared/api/instance';
import { config } from 'shared/config';
import { SSOErrors, SSOErrorsEnum } from '../consts/sso.error';
import {
  IChangePassword,
  IConfirmCodeDto,
  IEmailConfirmationDto,
  IEmailSendCodeDto,
  ISignInDto,
} from '../interfaces/sso.interfaces';

const API = instance(config.API_SSO);

export class SSOApi {
  public static async signIn(dto: ISignInDto): Promise<string> {
    try {
      const url = '/auth/sign-in';
      const res = await API.post(url, dto);
      return res.data.accessToken;
    } catch (error) {
      const err = error as { response?: { status: number } };
      switch (err.response?.status) {
        case 400:
          throw new Error(SSOErrors.SIGN_IN[400]);
        case 401:
          throw new Error(SSOErrors.SIGN_IN[401]);
        case 404:
          throw new Error(SSOErrors.SIGN_IN[404]);
        case 423:
          throw new Error(SSOErrors.SIGN_IN[423]);
        default:
          throw new Error(SSOErrorsEnum.SIGN_IN_DEFAULT);
      }
    }
  }
  public static async refreshSession(): Promise<string> {
    try {
      const url = `/auth/refresh`;
      const res = await API.get(url, { skipTokenWait: true } as any);
      return res.data.accessToken;
    } catch (error) {
      const err = error as { response?: { status: number } };
      if (err.response?.status === 401 || err.response?.status === 403) {
        const sessionExpiredError = new Error(
          SSOErrorsEnum.REFRESH
        ) as Error & { code: string };
        sessionExpiredError.code = 'SESSION_EXPIRED';
        throw sessionExpiredError;
      }
      throw new Error(SSOErrorsEnum.REFRESH);
    }
  }
  public static async logout() {
    try {
      const url = `/auth/logout`;
      return await API.get(url);
    } catch (error) {
      throw new Error(getErrorMessage(error, SSOErrorsEnum.LOGOUT));
    }
  }
  public static async emailSendCode(dto: IEmailSendCodeDto) {
    try {
      const url = `account/email-send-code`;
      return await API.get(url, { params: dto });
    } catch (error) {
      throw new Error(getErrorMessage(error, SSOErrorsEnum.SEND_CODE));
    }
  }
  public static async emailConfirmation(
    dto: IConfirmCodeDto
  ): Promise<IEmailConfirmationDto> {
    try {
      const url = `account/email-confirmation`;
      return (await API.get(url, { params: dto })).data;
    } catch (error) {
      throw new Error(getErrorMessage(error, SSOErrorsEnum.EMAIL_CONFIRM));
    }
  }
  public static async changePassword(dto: IChangePassword) {
    try {
      const url = `account/change-password`;
      return await API.patch(url, dto);
    } catch (error) {
      throw new Error(getErrorMessage(error, SSOErrorsEnum.CHANGE_PASSWORD));
    }
  }
}
